import React from "react";
import MediaQuery from "react-responsive";

export const DesktopOrLaptop = ({ children }) => (
  <MediaQuery minDeviceWidth={1224}>{children}</MediaQuery>
);
export const TabletOrMobile = ({ children }) => (
  <MediaQuery maxDeviceWidth={1224}>{children}</MediaQuery>
);
